import React, {useState} from 'react';
import FrontImage from '../src/components/Images/FrontImage.png';
import "./components/Cssfile/Login.css";
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const links = [
  {name: "Ozone Group Website",
    url: "https://ozonegroup.com",
  },
  {name: "Ozone Career Portal Link",
    url: "https://ozonegp.darwinbox.in/ms/candidate/careers",
  },
  {name: "Darwin Box Link",
    url: "https://ozonegp.darwinbox.in",
  },
  {name: "TCS Website Link",
    url: "https://www4.tcsion.com/dotcom/TCSSMB/Login/login.html",
  },
  {name: "Swass Reporting Link",
    url: "https://ozonegroup.hidoctor.me",
  },
  {name: "VOU Request Link - Proton",
    url: "https://forms.gle/BTsW6sp4PckKLiHG9",
  },
  {name: "VOU Request Link - Nucleus",
    url: "https://docs.google.com/forms/d/e/1FAIpQLScLwQ7T6-rXB5XzosXTYBXnQdb6_ysfdzGCA-5C_HvnPBsIAg/viewform",
  },
  {name: "Official Email Link",
    url: "https://mail.ozonegp.com",
  },
];




function Login() {
  const d = new Date();
  const ServerDatedata = d.getDate() +"-"+(d.getMonth()+1)+"-"+d.getFullYear()+" "+d.getHours()+":"+d.getMinutes()+":"+d.getSeconds();
  
  const [values, setValues] = useState({
    loginid: '',
    password: '',
    lldate:ServerDatedata
  })



  const navigate = useNavigate();
  // axios.defaults.withCredentials = true;

  const onUseridChange = (e) => {
    setValues.loginid({loginid:e.target.value});
  }

  const onPasswordChange = (e) => {
    setValues({password:e.target.value});
  }
  
  const handleSubmit=(e) => {
    e.preventDefault();
    if(!values.loginid || !values.password)
    {
      return toast.error(("Please Fill Login id and Password"), { position: "top-center" });
    }
    axios.post('/user/login', values)
    .then(res => {
      if(res.data.Status === "Success")
      {
        navigate ('/Home');
        toast.success(("Login Successfully"), { position: "top-center" });
      }
      else{        
        toast.error(res.data.Error, { position: "top-center" });
      }
    })
    .then(err => console.log(err));
    
  }

  return (
    <>

<div className="main-container">

      {/* Left Side */}
      <div className="left-section">
        <h1>Ozone Url's</h1>

        <div className="links-box">
          {links.map((item, index) => (
            <a
              key={index}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="link-btn"
            >
              {item.name}
            </a>
          ))}
        </div>
      </div>

      {/* Right Side */}
      <div className="right-section">
        <div className="login-card">

          <img
            src={FrontImage}
            alt="User Icon"
            className="logo"
          />

          <h2>Ozone Group</h2>

          <form onSubmit={handleSubmit}>
            
              <input type="text" id="typeEmailX-2" placeholder="Enter User Id" onChange={e => setValues({...values, loginid: e.target.value})} />            
              <input type="password" id="typePasswordX-2" placeholder="Enter Password" onChange={e => setValues({...values, password: e.target.value})}/>
              <p className='forgot'><a href="/Forgotpassword">Forgot Password?</a></p>              
            <button className="login-btn" type="submit" onClick={handleSubmit}>Login</button>
            </form>
          <hr />
          <a href="https://ozonepharma.com" rel="noreferrer" target="_blank">Go to the Site</a>
        </div>
      </div>
    </div>   

    </>
  )
}

export default Login;